import { useEffect, useRef } from 'react'
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr'
import State from './state'
import { useHistory } from 'react-router-dom'
import api, { apiRoutes } from '../api';

let retryCount = 0

export const useSignalR = (onUserPurchase, onDrawStatus) => {
  const connectionRef = useRef(null)
  const [{NextDraw}, dispatch] = State()
  const nextDrawRef = useRef(NextDraw)
  const history = useHistory()

  useEffect(() => {
    nextDrawRef.current = NextDraw
  }, [NextDraw])

  useEffect(() => {
    if (window.SocialBot === false && !connectionRef.current) {
      const connection = new HubConnectionBuilder()
        .configureLogging(LogLevel.None)
        .withUrl(window.signalr_url + "")
        .withAutomaticReconnect()
        .build()

      connectionRef.current = connection

      connection.on("userPurchase", (data) => {
        const currentNextDraw = nextDrawRef.current
        const nextDrawData = JSON.parse(data)
        
        dispatch({ type: 'SignalRUpdate', SignalRUpdate: true })

        // In-place update for instant visual feedback (handles both PascalCase from Newtonsoft and camelCase)
        const nd = nextDrawData.NextDraw || nextDrawData.nextDraw
        if (nd && currentNextDraw) {
          const isNewPurchase = parseFloat(nd.CurrentJackpot ?? nd.currentJackpot) > parseFloat(currentNextDraw.currentJackpot)
                                || parseFloat(nd.CurrentSecondaryJackpot ?? nd.currentSecondaryJackpot) > parseFloat(currentNextDraw.currentSecondaryJackpot)
                                || parseFloat(nd.ActualJackpotAmount ?? nd.actualJackpotAmount) > parseFloat(currentNextDraw.actualJackpotAmount)
                                || parseFloat(nd.ActualWeeklyAmount ?? nd.actualWeeklyAmount) > parseFloat(currentNextDraw.actualWeeklyAmount)
                  
          if (isNewPurchase) {
            dispatch({
              type: 'NextDraw',
              NextDraw: {
                ...currentNextDraw,
                currentJackpot: nd.CurrentJackpot ?? nd.currentJackpot ?? currentNextDraw.currentJackpot,
                currentSecondaryJackpot: nd.CurrentSecondaryJackpot ?? nd.currentSecondaryJackpot ?? currentNextDraw.currentSecondaryJackpot,
                actualJackpotAmount: nd.ActualJackpotAmount ?? nd.actualJackpotAmount ?? currentNextDraw.actualJackpotAmount,
                actualWeeklyAmount: nd.ActualWeeklyAmount ?? nd.actualWeeklyAmount ?? currentNextDraw.actualWeeklyAmount,
                showJackpotGuaranteeText: nd.ShowJackpotGuaranteeText ?? nd.showJackpotGuaranteeText ?? currentNextDraw.showJackpotGuaranteeText,
                showWeeklyGuaranteeText: nd.ShowWeeklyGuaranteeText ?? nd.showWeeklyGuaranteeText ?? currentNextDraw.showWeeklyGuaranteeText
              },
            })
          }
        }

        // Full refresh to ensure complete data consistency
        setTimeout(() => {
          api.get(apiRoutes.OrganizationNextDraw + `?organizationId=${window.TLF_ID}`)
            .then(res => {
              dispatch({ type: 'NextDraw', NextDraw: { ...res.data.payload.data }});
            }).catch(() => {})
        }, 2000)
      })

      connection.on("drawStatus", (data) => {
        dispatch({ type: 'SET_LATEST_DRAW_STATUS', latestDrawStatus: data })
        if (data === 'Started' && !window.location.pathname.includes('/live-draw-display/')) {
          history.push('/')
        }
      })

      const startConnection = async () => {
        try {
          await connection.start()
          await connection.invoke("Subscribe", window.TLF_ID)
          retryCount = 0
        } catch (err) {
          retryCount++
          if (retryCount <= 5) {
            const delay = Math.min(30000, 5000 * retryCount)
            setTimeout(startConnection, delay)
          }
        }
      }

      startConnection()
    }

    const stopConnection = () => {
      if (connectionRef.current) {
        connectionRef.current.stop()
        connectionRef.current = null
      }
    }

    window.addEventListener('beforeunload', stopConnection)

    return () => {
      window.removeEventListener('beforeunload', stopConnection)
      stopConnection()
    }
  }, [onUserPurchase, onDrawStatus])
}
